<template>
    <div>
        <!--Header Components-->
        <base-header class="pb-6" type="">
          <b-row class="align-items-center py-4">
            <b-col lg="12" cols="12">
              <h6 class="h2 d-inline-block mb-0">{{language_terms[$route.name]}}</h6>
              <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                <route-breadcrumb/>
              </nav>
            </b-col>
          </b-row>
        </base-header>
        <b-container fluid class="mt--6">
          <div>
              <loading :active ="progressCounter > 0" 
                color= '#007bff'
                :width= '128'
                :height= '128'
                loader='dots'
                :can-cancel="true" 
                :is-full-page="fullPage">
              </loading>
          </div>
          <b-row>
            <b-col lg="12">
              <div class="card-wrapper">
                <card>
                  <b-row>
                    <b-col cols="12" class="mt--4 ml--3">
                        <b-tabs pills card>
                            <b-tab title="Account Receivables" @click="clickOnReportType('AR')">
                            </b-tab>
                            <b-tab title="Account Payables" @click="clickOnReportType('AP')" disabled>
                            </b-tab>
                        </b-tabs>
                    </b-col>          
                  </b-row>
                  <b-row class="mt--4" v-if="reportPayload.type=='AR'">
                    <b-col md="3">
                      <base-input :label="language_terms['TYPE']">
                        <el-select v-model="reportPayload.sub_type" filterable>
                          <el-option v-for="option in sub_type_options"
                                    :key="option.value"
                                    :label="option.label"
                                    :value="option.value">
                          </el-option>
                        </el-select>
                      </base-input>
                    </b-col>
                    <b-col md="3" >
                      <base-input :label="language_terms['DATE_AS_AT']">
                        <flat-picker slot-scope="{focus, blur}"
                                    @on-open="focus"
                                    @on-close="blur"
                                    style="background-color: white;"
                                    class="form-control datepicker"
                                    v-model="reportPayload.date_as_at">
                        </flat-picker>
                      </base-input>
                    </b-col>
                    <b-col cols="2" class="mt-4">
                      <base-button type="primary" @click="onClickDownload" class="mt-2 mr-4">{{language_terms['DOWNLOAD']}}</base-button>
                    </b-col>
                  </b-row>
                  <b-row class="mt--4" v-if="reportPayload.type=='AP'">
                    <b-col md="3">
                      <base-input :label="language_terms['TYPE']">
                        <el-select v-model="reportPayload.sub_type" filterable>
                          <el-option v-for="option in sub_type_options"
                                    :key="option.value"
                                    :label="option.label"
                                    :value="option.value">
                          </el-option>
                        </el-select>
                      </base-input>
                    </b-col>
                    <b-col md="3" >
                      <base-input :label="language_terms['DATE_AS_AT']">
                        <flat-picker slot-scope="{focus, blur}"
                                    @on-open="focus"
                                    @on-close="blur"
                                    style="background-color: white;"
                                    class="form-control datepicker"
                                    v-model="reportPayload.date_as_at">
                        </flat-picker>
                      </base-input>
                    </b-col>
                    <b-col cols="2" class="mt-4">
                      <base-button type="primary" @click="onClickDownload" class="mt-2 mr-4">{{language_terms['DOWNLOAD']}}</base-button>
                    </b-col>
                  </b-row>
                </card>
              </div>
            </b-col>
          </b-row>
        </b-container>
    </div>
  </template>
  <style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
  <style>
  th.VueTables__sortable {
      color:rgb(255,255,255);
  }
  td.VueTables__row  {
      color:black
  }
  .v-data-table /deep/ .sticky-header {
    position: sticky;
    top: var(--toolbarHeight);
  }
  
  .v-data-table /deep/ .v-data-table__wrapper {
    overflow: unset;
  }
  </style>
  <script>
  import productLookup from "@/components/Autocomplete.vue";
  import moment from 'moment'
  import { Select, Option,Table, TableColumn, Dropdown, DropdownMenu, DropdownItem } from "element-ui";
  import flatPicker from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';  
  import { mapState } from "vuex";
  import PaginatedTables from '@/views/Tables/PaginatedTables'
  import axios from "axios";
  import { saveAs } from 'file-saver';
  import { apiRoutes } from "../../apiRoutes";
  import { authHeader } from "../../global";
  import { exit } from "process";
  
  export default {
    components:{
      productLookup,
      Loading,
      [Select.name]: Select,
      [Option.name]: Option,
      flatPicker,
      PaginatedTables
    },
    computed: {
      ...mapState({
          language_terms: (state) => state.languages.language_terms,
          selected_lang: (state) => state.languages.selected_langauge,
      })
    },  
    async mounted()
    {
      this.reportPayload.date_as_at = moment().format("YYYY-MM-DD")
      this.reportPayload.type = 'AR'
      this.reportPayload.sub_type = 'SUMMARY'      
    },
    data(){
      return {
        reportPayload:{
          type: 'AR',
          sub_type: 'SUMMARY',
          date_as_at: null,
        },
        sub_type_options:[
        {
          label:"Summary",
          value:"SUMMARY"
        },
        {
          label:"Details",
          value:"DETAILS"
        },
      ],
      fullPage:true,
      progressCounter:0,
      }
    },
  
    methods:{
      clickOnReportType(type)
      {
        this.reportPayload.type = type
      },
      async onClickDownload(){
        this.progressCounter++
        let header = authHeader();
        header.responseType = 'blob';

        let payload = this.reportPayload;
        await axios.post(apiRoutes["REPORTS_DOWNLOAD_AGEING"], payload, header).then((response) => {
          // const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const blob = new Blob([response.data]);

          // Use FileSaver.js to save the Blob object as a file
          let filename = this.reportPayload.type + '_AGEING_' + this.reportPayload.sub_type + '_' + this.reportPayload.date_as_at + '.xlsx'
          saveAs(blob, filename);
        })
        .catch((error) => {
            if (error.response) {
            console.log(error.response);
            Vue.notify({
                group: "notify",
                type: "error",
                text: error.response.data.msg,
                max: 5,
                duration: 5000,
                speed: 300,
            });
            } else {
            console.log("Problem submitting New Post", error);
            }
        });        

        this.progressCounter--
      },
    }
  }
  </script>
  